import { useCallback, useEffect, useState } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useGetAssemblies } from './hooks/useGetAssemblies';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import { useNavbarHeight } from '@/hooks/useNavbarHeight';
import { ReviewScreenHeader } from './ReviewScreenHeader';
import { TabNavigation } from './TabNavigation';

export const ReviewScreen = () => {
  const [selectedAssemblyId, setSelectedAssemblyId] = useAtom(state.selectedAssemblyId);
  const setSelectedAssemblyName = useSetAtom(state.selectedAssemblyName);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navbarHeight = useNavbarHeight();
  useGetAssemblies();

  const handleClose = useCallback(() => {
    setDrawerOpen(false);
    setSelectedAssemblyId(undefined);
    setSelectedAssemblyName(undefined);
  }, [setSelectedAssemblyId, setSelectedAssemblyName]);

  useEffect(() => {
    setDrawerOpen(!!selectedAssemblyId);
  }, [selectedAssemblyId]);

  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={handleClose}
      PaperProps={{
        sx: { width: '70vw', backgroundColor: '#fff' },
      }}
      transitionDuration={300}
    >
      <Stack sx={{ paddingTop: `${navbarHeight}px`, overflowY: 'auto', height: '100%' }}>
        {selectedAssemblyId && (
          <>
            <ReviewScreenHeader handleClose={handleClose} />
            <TabNavigation />
          </>
        )}
      </Stack>
    </Drawer>
  );
};
